import {pushFaroError, pushFaroLog} from '../faro';
import {LogLevel} from '@grafana/faro-web-sdk';

interface CaptureMessageOptions {
    tags: any[];
    extra: object;
}

/**
 * Capture an exception with tags.
 *
 * @param {Error} err
 * @param {CaptureMessageOptions} [options]
 */
export function captureException(err: Error, options?: CaptureMessageOptions) {
    pushFaroError(err);
}

/**
 * Capture a message with tags.
 *
 * @param {string} message
 * @param {CaptureMessageOptions} [options]
 */
export function captureMessage(message: string, options?: CaptureMessageOptions) {
    pushFaroLog(message, LogLevel.INFO);
}